import { z } from "zod";

export const OAuthProviderSchema = z.enum(["GOOGLE", "NAVER", "KAKAO"]);

export const OAuthCallbackParamsSchema = z.object({
	accessToken: z.string(),
	refreshToken: z.string(),
});

export type OAuthProvider = z.infer<typeof OAuthProviderSchema>;
export type OAuthCallbackParams = z.infer<typeof OAuthCallbackParamsSchema>;
